// extracted by mini-css-extract-plugin
export default {"dropdownFitContent":"selectDropdownFitContent_dropdownFitContent__vsVL5"};